import { ProgressSpinner } from "primereact/progressspinner";

const CircularLoader = ({ size = 40 }) => {
  return (
    <div
      className="flex justify-content-center align-items-center"
      style={{ width: `100%`, height: `${size}px` }}
    >
      <ProgressSpinner />
    </div>
  );
};

export default CircularLoader;
